/**
 * format — locale-neutral formatting utilities for ai-admin
 */

import { format as fnsFormat, type Locale } from 'date-fns'

let currentLocale: Locale | undefined

/** Set the default locale used by formatDate */
export function setLocale(locale: Locale): void {
  currentLocale = locale
}

/** Format a date using date-fns. Default pattern: 'yyyy-MM-dd' */
export function formatDate(date: Date | number | string, pattern = 'yyyy-MM-dd'): string {
  return fnsFormat(new Date(date), pattern, currentLocale ? { locale: currentLocale } : undefined)
}

/** Format a number with locale-appropriate separators */
export function formatNumber(n: number): string {
  return n.toLocaleString()
}

/** Format a credit count (locale-neutral, no suffix) */
export function formatCredits(n: number): string {
  return n.toLocaleString()
}

/** Format a percentage with one decimal place */
export function formatPercent(n: number): string {
  return `${n.toFixed(1)}%`
}

/** Format a currency amount */
export function formatCurrency(amount: number): string {
  return amount.toLocaleString()
}
